import Vue from 'vue'
import moment from 'moment'

/**
 * directive: 日付を指定のフォーマットに変更する
 * @param { string } format - 日付フォーマットを入れる
 * <span v-date-format="YYYY年M月DD日">2017-10-2</span>
 * => 2017年10月02日
 */
Vue.directive('date-format', {
  bind(el, binding) {
    const date = moment(el.textContent)
    if (date.isValid() && binding.value) {
      Object.assign(el, { textContent: date.format(binding.value) })
    } else {
    }
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/dateformat.js